import React from 'react'
import { LeadParams } from './types'

/**
 * Context to provide access to lead data / params
 */
export default React.createContext<LeadParams>({})
